import React from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { AddCommaNumber } from "../../../helpers/Utils";
import { Row } from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";

// Helper function to render ranking badge
const RankingBadge = ({ ranking }) => {
  if (!ranking) return <span className="text-muted">-</span>;

  const badgeColors = {
    1: { bg: "#ffd700", color: "#000" }, // Gold
    2: { bg: "#c0c0c0", color: "#000" }, // Silver
    3: { bg: "#cd7f32", color: "#fff" }, // Bronze
  };

  const style = badgeColors[ranking] || { bg: "#6c757d", color: "#fff" };

  return (
    <span
      className="badge font-weight-bold"
      style={{
        backgroundColor: style.bg,
        color: style.color,
        fontSize: ranking <= 3 ? "14px" : "12px",
        padding: "4px 8px",
      }}
    >
      {ranking <= 3 ? (
        <>
          <IntlMessages id="analytics.staff.top" /> {ranking}
        </>
      ) : (
        `#${ranking}`
      )}
    </span>
  );
};

const StaffAnalytics = (props) => {
  const { summary, data } = props;

  return (
    <div>
      {/* Staff Performance Table */}
      <ReactTable
        defaultPageSize={10}
        data={data || []}
        getTrProps={(state, rowInfo) => {
          // Làm mờ row nếu nhân viên đã nghỉ việc
          if (
            rowInfo &&
            rowInfo.original &&
            rowInfo.original.status_working !== "on"
          ) {
            return {
              style: {
                opacity: 0.5,
                backgroundColor: "#f8f9fa",
              },
            };
          }
          return {};
        }}
        columns={[
          {
            Header: <IntlMessages id="analytics.staff.rank" />,
            accessor: "ranking",
            width: 80,
            sortable: false,
            Cell: (row) => (
              <div className="text-center">
                <RankingBadge ranking={row.value} />
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.name" />,
            accessor: "name",
            Cell: (row) => (
              <div className="text-left font-weight-bold">{row.value}</div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.position" />,
            accessor: "permission_name",
            Cell: (row) => (
              <div className="text-center">{row.value || "-"}</div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.sales" />,
            accessor: "total_sales",
            Cell: (row) => (
              <div
                className="text-center font-weight-bold"
                style={{ color: "#28a745" }}
              >
                {AddCommaNumber(row.value)}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.bill_count" />,
            accessor: "bill_count",
            Cell: (row) => (
              <div className="text-center" style={{ color: "#007bff" }}>
                {row.value || 0}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.product_count" />,
            accessor: "product_count",
            Cell: (row) => (
              <div className="text-center" style={{ color: "#6c757d" }}>
                {row.value || 0}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.revenue_per_hour" />,
            accessor: "revenue_per_hour",
            Cell: (row) => (
              <div
                className="text-center font-weight-bold"
                style={{ color: "#17a2b8" }}
              >
                {AddCommaNumber(row.value || 0)}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.commission" />,
            accessor: "commission",
            Cell: (row) => (
              <div className="text-center text-info font-weight-bold">
                {AddCommaNumber(row.value)}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.bonus" />,
            accessor: "bonus",
            Cell: (row) => (
              <div className="text-center" style={{ color: "#20c997" }}>
                {AddCommaNumber(row.value)}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.overtime" />,
            accessor: "overtime_hours",
            Cell: (row) => (
              <div className="text-center" style={{ color: "#fd7e14" }}>
                {row.value || 0}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.advance" />,
            accessor: "advence",
            Cell: (row) => (
              <div className="text-center" style={{ color: "#6f42c1" }}>
                {AddCommaNumber(row.value)}
              </div>
            ),
          },
          {
            Header: <IntlMessages id="analytics.staff.fined" />,
            accessor: "fined",
            Cell: (row) => (
              <div
                className={`text-center ${row.value > 0 ? "text-danger font-weight-bold" : ""}`}
              >
                {AddCommaNumber(row.value)}
              </div>
            ),
          },
        ]}
        minRows={0}
        showPageJump={false}
        showPageSizeOptions={false}
        PaginationComponent={Pagination}
        NoDataComponent={() => (
          <div className="text-center text-muted py-3">
            <IntlMessages id="analytics.staff.no_data" />
          </div>
        )}
        className="equal-columns-table"
      />
    </div>
  );
};

export default StaffAnalytics;
